import "./TraineeProfile.css";

export default function TraineeCatalogHero({ eyebrow, title, subtitle }) {
  return (
    <section className="tp-hero tp-hero--catalog">
      <div className="tp-hero-inner tp-hero-inner--simple">
        <div className="tp-hero-copy">
          <p className="tp-eyebrow">{eyebrow}</p>
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
      </div>
    </section>
  );
}
